import { inject, Pipe, PipeTransform } from '@angular/core';

import {
	COMMON_ENVIRONMENT,
	CommonEnvironment,
	CommonEnvironmentName,
} from '../tokens/environment';

export function http2Https(url: string, environment: CommonEnvironment): string {
	const parsedUrl = url || '';
	const convert = environment.environmentName !== CommonEnvironmentName.LOCAL;

	if (typeof parsedUrl === typeof 'string') {
		const trimmedUrl = parsedUrl.trim();

		const isHttp = trimmedUrl.startsWith('http://');

		const isLocalhost = !convert;

		if (isHttp && !isLocalhost) {
			const withoutProtocol = trimmedUrl.substr(7);
			return `https://${withoutProtocol}`;
		}

		return parsedUrl;
	}

	return url;
}

@Pipe({
	pure: true,
	name: 'https',
	standalone: true,
})
export class Http2HttpsPipe implements PipeTransform {
	private readonly clientEnvironment = inject(COMMON_ENVIRONMENT);

	transform(url: string): string {
		return http2Https(url, this.clientEnvironment);
	}
}
